import { useTranslation } from 'react-i18next';

const useTranslatedValue = key => {
  const { t } = useTranslation('translationsNm');
  return t(key);
};

export default useTranslatedValue;
